import {ViewName} from "@kta20-core/interfaces/view-name";
import {ViewNames} from "@kta20-ewo-definition/constants";

export const ModuleViews: ViewName[] = [
    {
        name: ViewNames.EWO_FORM_VIEW,
        loader: async () => { await import(`@kta20-ewo-definition/views/ewo-form-view/ewo-form-view`); },
        loaded: false
    },
    {
        name: ViewNames.EWO_REPORTING_VIEW,
        loader: async () => { await import(`@kta20-ewo-definition/views/ewo-reporting-view/ewo-reporting-view`); },
        loaded: false
    },
    {
        name:ViewNames.CRN_KNOWLEDGEBASE_VIEW,
        loader:async()=>{await import(`@kta20-ewo-definition/views/crn-knowledgebase-list/crn-knowledgebase-list-view`); },
        loaded:false
    }
];
